import { Button } from 'antd'
import React from 'react'
import { TDefaultSagas } from 'hootsuite/stream/redux/interface'
import { useSelector, useDispatch } from 'react-redux'
import { THeaderActionsState } from 'hootsuite/stream/redux/headeractions/reducers'

const HeaderActions = () => {
  const headerActions: THeaderActionsState = useSelector((state: TDefaultSagas) => state.headerActions)
  const dispatch = useDispatch()

  const size = 1

  return (
    <div>
      { headerActions.mainAction &&
        <Button onClick={()=>{
          dispatch(
            {
              type: headerActions.mainAction?.action,
              payload: {}
            }
          )
        }}>{headerActions.mainAction.label}</Button>
      }
    </div>
  )
}

export default HeaderActions